export class NewGoodsProposalModel {
  public allCoop = false;

  constructor(
    public proposalId = '',
    public proposalStatus = '',
    public classCode = '',
    public buyerUserId = '',
    public goodsName = '',
    public standardName = '',
    public janCode = '',
    public salesPoint = '',
    public standardSellingPrice = '',
    public special1SellingPrice = '',
    public special2SellingPrice = '',
    public standardCostPrice = '',
    public special1CostPrice = '',
    public special2CostPrice = '',
    public standardGpr = '',
    public special1Gpr = '',
    public special2Gpr = '',
    public expirationDate = '',
    public bestBeforeDate = '',
    public preferredOrderCode = '',
    public preferredDelivCatalogId = '',
    public preferredExpansionDiv = '1',
    public preferredExpansionOther = '',
    public expandableCoop = {
      ibaraki: false,
      tochigi: false,
      gunma: false,
      chiba: false,
      saitama: false,
      tokyo: false,
      nagano: false,
      niigata: false
    },
    public monthAge = '',
    public productionFactory = '',
    public manufacturingFactory = '',
    public deliGoodsChecked = false,
    public goodsCheckRequest = false,
    public temperatureDiv = '',
    public orderClientName = '',
    public markerName = '',
    public allergen = '',
    public additives = '',
    public cookingMethod = '',
    public mobRegistered = false,
    public shootingInstruction = '',
    public imageFileName = '',
    public shootingImage = '',
    public note = '',
    public rejectedReason = '',
    public predictedPoints = '',
  ) {
    this.allCoop = Object.values(this.expandableCoop).every(coop => coop);
  }

  copy() {
    return new NewGoodsProposalModel(
      this.proposalId,
      this.proposalStatus,
      this.classCode,
      this.buyerUserId,
      this.goodsName,
      this.standardName,
      this.janCode,
      this.salesPoint,
      this.standardSellingPrice,
      this.special1SellingPrice,
      this.special2SellingPrice,
      this.standardCostPrice,
      this.special1CostPrice,
      this.special2CostPrice,
      this.standardGpr,
      this.special1Gpr,
      this.special2Gpr,
      this.expirationDate,
      this.bestBeforeDate,
      this.preferredOrderCode,
      this.preferredDelivCatalogId,
      this.preferredExpansionDiv,
      this.preferredExpansionOther,
      { ...this.expandableCoop },
      this.monthAge,
      this.productionFactory,
      this.manufacturingFactory,
      this.deliGoodsChecked,
      this.goodsCheckRequest,
      this.temperatureDiv,
      this.orderClientName,
      this.markerName,
      this.allergen,
      this.additives,
      this.cookingMethod,
      this.mobRegistered,
      this.shootingInstruction,
      this.imageFileName,
      this.shootingImage,
      this.note,
      this.rejectedReason,
      this.predictedPoints
    );
  }
}